<header>
    <h2>{{ formTitle }}</h2>
    <p *ngIf="!forgotPasswordFail && !forgotPasswordSuccess">{{ formInstruction }}</p>
    <mat-error *ngIf="forgotPasswordFail">
      {{forgotFailText}}
    </mat-error>
    <p *ngIf="forgotPasswordSuccess">{{forgotSuccessText}}</p>
  </header>
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" *ngIf="!forgotPasswordSuccess">
    <div class="email">
      <mat-form-field appearance="outline">
        <input matInput placeholder="Enter your email address" formControlName="email">
      </mat-form-field>
      <div *ngIf="email.touched && email.errors">
        <mat-error *ngIf="email.errors?.email">
          Enter a valid email address
        </mat-error>
        <mat-error *ngIf="email.errors?.required">
          Enter an email address
        </mat-error>
      </div>
    </div>
    <div class="modal-buttons">
      <button class="a-rounded-button a-rounded-button--primary" type="submit"
        [disabled]="forgotPasswordForm.invalid || showSpinner">Send</button>
      <button [routerLink]="['/auth/signin']" class="a-rounded-button a-rounded-button--primary-outline">Cancel</button>
    </div>
  </form>
  <footer *ngIf="forgotPasswordSuccess">
    <button [routerLink]="['/auth/signin']" class="a-rounded-button a-rounded-button--primary-outline">Back</button>
  </footer>